import React, { useEffect, useState } from "react";
import { DashboardSummaryTab } from "../IndexOverviewPoint";
import { Col, ConfigProvider, Row, Table } from "antd";
import Input from "../../../../components/Input/Input";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import Text from "../../../../components/Text/Text";
import { FlexCol } from "../../../../components/Container/Container";
import { numberFormatter } from "../../../../utility/Formatter";

export const CampaignTab = () => {
  const { companyType } = JSON.parse(localStorage.getItem("company")!);
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);

  const mockData = [
    {
      key: "1",
      campaignName: "แคมเปญตัวอย่าง",
      dateTime: "01/01/2024 - 31/01/2024",
      status: "Active",
      shopCount: 10,
      totalVolume: 100,
      pendingPoints: 50,
      availablePoints: 200,
      expiringPoints: 20,
      redeemedPoints: 30,
      expiredPoints: 10,
      shopList: [
        {
          shopId: 1,
          shopName: "ร้านตัวอย่าง 1",
          shopCount: 10,
          totalVolume: 100,
          pendingPoints: 50,
          availablePoints: 200,
          expiringPoints: 20,
          redeemedPoints: 30,
          expiredPoints: 10,
        },
        {
          shopId: 2,
          shopName: "ร้านตัวอย่าง 2",
          shopCount: 10,
          totalVolume: 100,
          pendingPoints: 50,
          availablePoints: 200,
          expiringPoints: 20,
          redeemedPoints: 30,
          expiredPoints: 10,
        },
      ],
    },
    {
      key: "2",
      campaignName: "แคมเปญตัวอย่าง",
      dateTime: "01/01/2024 - 31/01/2024",
      status: "Active",
      shopCount: 10,
      totalVolume: 100,
      pendingPoints: 50,
      availablePoints: 200,
      expiringPoints: 20,
      redeemedPoints: 30,
      expiredPoints: 10,
      shopList: [
        {
          shopId: 1,
          shopName: "ร้านตัวอย่าง 1",
          shopCount: 10,
          totalVolume: 100,
          pendingPoints: 50,
          availablePoints: 200,
          expiringPoints: 20,
          redeemedPoints: 30,
          expiredPoints: 10,
        },
        {
          shopId: 2,
          shopName: "ร้านตัวอย่าง 2",
          shopCount: 10,
          totalVolume: 100,
          pendingPoints: 50,
          availablePoints: 200,
          expiringPoints: 20,
          redeemedPoints: 30,
          expiredPoints: 10,
        },
      ],
    },
  ];

  const columns =
    companyType === "Fertilizer"
      ? [
          {
            title: "ชื่อแคมเปญ",
            dataIndex: "campaignName",
            key: "campaignName",
          },
          {
            title: "ระยะเวลา",
            dataIndex: "dateTime",
            key: "dateTime",
          },
          {
            title: "สถานะ",
            dataIndex: "status",
            key: "status",
          },
          {
            title: "จำนวนร้าน",
            dataIndex: "shopCount",
            key: "shopCount",
          },
          {
            title: "ปริมาณรวม (ตัน)",
            dataIndex: "totalVolume",
            key: "totalVolume",
          },
          {
            title: "รออนุมัติแต้ม",
            dataIndex: "pendingPoints",
            key: "pendingPoints",
          },
          {
            title: "แต้มที่ใช้ได้",
            dataIndex: "availablePoints",
            key: "availablePoints",
          },
          {
            title: "แต้มใกล้หมดอายุ 30 วัน",
            dataIndex: "expiringPoints",
            key: "expiringPoints",
          },
          {
            title: "แต้มที่แลกแล้ว",
            dataIndex: "redeemedPoints",
            key: "redeemedPoints",
          },
          {
            title: "แต้มหมดอายุ",
            dataIndex: "expiredPoints",
            key: "expiredPoints",
          },
        ]
      : [
          {
            title: "ชื่อแคมเปญ",
            dataIndex: "campaignName",
            key: "campaignName",
          },
          {
            title: "ระยะเวลา",
            dataIndex: "dateTime",
            key: "dateTime",
          },
          {
            title: "สถานะ",
            dataIndex: "status",
            key: "status",
          },
          {
            title: "จำนวนร้าน",
            dataIndex: "shopCount",
            key: "shopCount",
          },
          {
            title: "แต้มรอกดรับสินค้า",
            dataIndex: "pendingPoints",
            key: "pendingPoints",
          },
          {
            title: "แต้มที่ใช้ได้",
            dataIndex: "availablePoints",
            key: "availablePoints",
          },
        ];

  return (
    <>
      <DashboardSummaryTab />
      <br />
      <Row justify='space-between' style={{ alignItems: "center" }}>
        <Col span={8}>
          <Input autoComplete='off' placeholder='รหัส / ชื่อแคมเปญ' suffix={<SearchOutlined />} />
        </Col>
        <Col>
          <Text color='Text3'>ทั้งหมด 4 รายการ</Text>
        </Col>
      </Row>
      <br />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={mockData}
          scroll={{ x: "max-content" }}
          expandable={{
            expandedRowKeys,
            onExpandedRowsChange: (keys: any) => {
              setExpandedRowKeys(keys);
            },
            expandedRowRender: (record: any) => {
              return (
                <Table
                  showHeader={false}
                  columns={
                    companyType === "Fertilizer"
                      ? [
                          {
                            dataIndex: "shopName",
                            key: "shopName",
                            width: "33.5%",
                            render: (value: any, record: any) => <Text>{value}</Text>,
                          },
                          {
                            dataIndex: "shopCount",
                            key: "shopCount",
                            width: "7.7%",
                            render: (value: any, record: any) => (
                              <FlexCol>
                                <Text>{value}</Text>
                              </FlexCol>
                            ),
                          },
                          {
                            dataIndex: "totalVolume",
                            key: "totalVolume",
                            width: "10.7%",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                          {
                            dataIndex: "pendingPoints",
                            key: "pendingPoints",
                            width: "9%",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                          {
                            dataIndex: "availablePoints",
                            key: "availablePoints",
                            width: "7.5%",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                          {
                            dataIndex: "expiringPoints",
                            key: "expiringPoints",
                            width: "13.8%",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                          {
                            dataIndex: "redeemedPoints",
                            key: "redeemedPoints",
                            width: "9.6%",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                          {
                            dataIndex: "expiredPoints",
                            key: "expiredPoints",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                        ]
                      : [
                          {
                            dataIndex: "shopName",
                            key: "shopName",
                            width: "55.5%",
                            render: (value: any, record: any) => <Text>{value}</Text>,
                          },
                          {
                            dataIndex: "shopCount",
                            key: "shopCount",
                            width: "12.8%",
                            render: (value: any, record: any) => (
                              <FlexCol>
                                <Text>{value}</Text>
                              </FlexCol>
                            ),
                          },
                          {
                            dataIndex: "pendingPoints",
                            key: "pendingPoints",
                            width: "19.5%",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                          {
                            dataIndex: "availablePoints",
                            key: "availablePoints",
                            render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                          },
                        ]
                  }
                  dataSource={record?.shopList}
                  pagination={false}
                  size='small'
                />
              );
            },
            expandIcon: ({
              expanded,
              onExpand,
              record,
            }: {
              expanded: boolean;
              onExpand: any;
              record: any;
            }) => {
              return expanded ? (
                <UpOutlined onClick={(event) => onExpand(record, event)} />
              ) : (
                <DownOutlined onClick={(event) => onExpand(record, event)} />
              );
            },
          }}
          pagination={{
            pageSize: 10,
            current: 1,
            total: 20,
            showSizeChanger: false,
            position: ["bottomCenter"],
            // onChange: (page) => {
            //   const nextPage = String(page);
            //   //setPage(nextPage);
            //   //setParams({ page: nextPage });
            // },
          }}
        />
      </ConfigProvider>
    </>
  );
};
